<template>
  <div>
      <b-row>
        <b-col md="12">
          <b-button @click="getOrderSummary" variant="info" class="float-right"><font-awesome-icon icon="redo-alt"></font-awesome-icon> Refresh</b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3 mb-3">
        <b-col md="12">
          <b-card>
            <h5><strong>List Produk Stok</strong></h5>
            <table class="table table-striped">
              <tr>
                <th>Name</th>
                <th class="text-center">Stok</th>
                <th class="text-center">Min. Stok</th>
                <th></th>
              </tr>
              <template v-if="listProductSize.length > 0">
                <tr v-for="productSize in listProductSize" :key="productSize.id">
                  <td>{{productSize.product_color.product_categories.product.name}} - 
                      {{productSize.product_color.product_categories.category.name}} - 
                      {{productSize.product_color.color.name}} - 
                      {{productSize.size.name}}</td>
                  <td class="text-center">{{productSize.stock}}</td>
                  <td class="text-center">{{productSize.min_stock}}</td>
                  <td>
                    <b-button type="button" variant="primary" size="sm" @click="showModal(productSize)"><font-awesome-icon icon="edit"/></b-button>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td class="text-center" colspan="4">Tidak ada untuk saat ini.</td>
                </tr>
              </template>
            </table>
          </b-card>
        </b-col>
      </b-row>
      <div class="row">
        <div class="col-xl-4 col-md-6">
          <stats-card :title="model.member" :subTitle="'Total Member'">
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-paper-2 text-warning"></i>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card :title="model.spesial_member" subTitle="Total Spesial Member">
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-badge text-success"></i>
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-6">
          <stats-card :title="model.pelanggan" subTitle="Total Pelanggan">
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-circle-09 text-danger"></i>
            </div>
          </stats-card>
        </div>
      </div>
      <div class="row">
        
      </div>
      <div class="row">

        <div class="col-md-6">
          <template v-if="isLoading">
            <font-awesome-icon icon="spinner" spin></font-awesome-icon>
          </template>
          <template v-else>
            <b-card>
              <h5><strong>Status Order</strong></h5>
              <apexchart type="donut" height="263" :options="chartOptions" :series="series"></apexchart>
            </b-card>
          </template>
        </div>
        <b-col md="6">
          <b-row>
            <div class="col-xl-12 col-md-12">
              <stats-card :title="model.dropshipper" :subTitle="'Total Dropshipper'">
                <div slot="header" class="icon-warning">
                  <i class="nc-icon nc-delivery-fast text-warning"></i>
                </div>
                
              </stats-card>
            </div>
            <div class="col-xl-12 col-md-12">
              <stats-card :title="model.gold_member" :subTitle="'Total Gold Member'">
                <div slot="header" class="icon-warning">
                  <i class="nc-icon nc-delivery-fast text-warning"></i>
                </div>
                
              </stats-card>
            </div>

            <div class="col-xl-12 col-md-12">
              <stats-card :title="model.barang" subTitle="Total Barang">
                <div slot="header" class="icon-success">
                  <i class="nc-icon nc-backpack text-success"></i>
                </div>
              </stats-card>
            </div>

            <div class="col-xl-12 col-md-12">
              <stats-card :title="model.pengunjung" subTitle="Total Pengunjung">
                <div slot="header" class="icon-danger">
                  <i class="nc-icon nc-satisfied text-info"></i>
                </div>
              </stats-card>
            </div>
          </b-row>
        </b-col>
        <!-- <div class="col-md-6">
          <template v-if="isLoading">
            <font-awesome-icon icon="spinner" spin></font-awesome-icon>
          </template>
          <template v-else>
            <b-card>
              <h5><strong>Statik Order Bulanan</strong></h5>
              <apexchart type="bar" height="350" :options="chartOptionsLine" :series="seriesLine"></apexchart>
            </b-card>
          </template>
        </div> -->
      </div>
  </div>
</template>
<script>
  import {ChartCard, StatsCard, Card, Table as LTable, Checkbox} from '@/components/index'
  import VueApexCharts from 'vue-apexcharts'
  import Vue from 'vue'
  // Vue.use(VueApexCharts)
  
  Vue.component('apexchart', VueApexCharts)

  export default {
    components: {
      Checkbox,
      Card,
      LTable,
      ChartCard,
      StatsCard
    },
    data () {
      return {
        isLoading: true,
        saveButtonData: {
          isLoading: false,
          state: 1
        },
        apiUrl: {
          productSize: window.AppConfig.apiUrl + 'product-size?min_stock=1',
          productSizePrice: window.AppConfig.apiUrl + 'product-size-price'
        },
        model: {
          dropshipper: 0,
          gold_member: 0,
          member: 0,
          pelanggan: 0,
          spesial_member: 0,
          barang: 0,
          pengunjung: 0
        },
        listProductSize: [],
        projectCount: null,
        userCount: null,
        customerCount: null,
        projectStatus: null,
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        series: [],
        chartOptions: {
          chart: {
            width: 380,
            type: 'donut'
          },
          labels: ['Pending', 'Lunas', 'Batal', 'Tahan'],
          colors: ['#fd7e14', '#28a745', '#dc3545', '#6c757d'],
          dataLabels: {
            enabled: false
          },
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                show: false
              }
            }
          }],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 230
          }
        },
        seriesLine: [{
          name: 'Marine Sprite',
          data: [44, 55, 41, 37, 22, 43, 21]
        }, {
          name: 'Striking Calf',
          data: [53, 32, 33, 52, 13, 43, 32]
        }, {
          name: 'Tank Picture',
          data: [12, 17, 11, 9, 15, 11, 20]
        }, {
          name: 'Bucket Slope',
          data: [9, 7, 5, 8, 6, 9, 4]
        }],
        chartOptionsLine: {
          chart: {
            type: 'bar',
            height: 350,
            stacked: true
          },
          plotOptions: {
            bar: {
              horizontal: true
            }
          },
          colors: ['#fd7e14', '#28a745', '#dc3545', '#6c757d'],
          stroke: {
            width: 1,
            colors: ['#fff']
          },
          title: {
            text: ''
          },
          xaxis: {
            categories: [2008, 2009, 2010, 2011, 2012, 2013, 2014],
            labels: {
              formatter: function (val) {
                return val + 'K'
              }
            }
          },
          yaxis: {
            title: {
              text: undefined
            }
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + 'K'
              }
            }
          },
          fill: {
            opacity: 1
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40
          }
        }
      }
    },
    mounted () {
      this.getOrderSummary()
      this.getProductSize()
    },
    methods: {
      getOrderSummary () {
        this.isLoading = true
        this.$http.get(window.AppConfig.apiUrl + 'dasboard-summary')
        .then((response) => {
          this.model.dropshipper = response.data.dropshipper
          this.model.gold_member = response.data.gold_member
          this.model.member = response.data.member
          this.model.pelanggan = response.data.pelanggan
          this.model.spesial_member = response.data.spesial_member
          this.model.barang = response.data.barang
          this.model.pengunjung = response.data.pengunjung.total_today
          this.series = []
          Object.keys(response.data.statistikk_order).forEach(data => {
            this.series.push(response.data.statistikk_order[data])
          })
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        })
      },
      getProductSize () {
        this.isLoading = true
        this.$http.get(this.apiUrl.productSize)
        .then((response) => {
          this.listProductSize = []
          response.data.data.forEach(data => {
            if (data.min_stock !== null && data.stock <= data.min_stock) {
              this.listProductSize.push(data)
            }
          })
          this.isLoading = false
        })
        .catch(error => {
          this.isLoading = false
          this.$store.dispatch('notification/error', error)
        })
      },
      dorefresh () {
        this.getOrderSummary()
        this.getProductSize()
      },
      showModal (value) {
        this.modelProductSize.id = value.id
        this.$refs['my-modal'].show()
      },
      hideModal () {
        this.modelProductSize.stock = null
        this.$refs['my-modal'].hide()
      },
      doUpdated () {
        this.$http.patch(this.apiUrl.productSizePrice + '/' + this.modelProductSize.id, {
          stock: this.modelProductSize.stock
        }).then(data => {
          this.$store.dispatch('notification/success', 'Stock product berhasil diperbaharui.')
          this.getProductSize()
          this.hideModal()
        })
        .catch(error => {
          this.$store.dispatch('notification/error', error)
        })
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Dashboard.vue